export default __webpack_public_path__ + "static/tooltip-info-do-light-5aa89c346cfdb6541dfd6c0298827f1c.png";